import { createContext, useContext } from 'react';

export const ListTableVariantContext = createContext();

export const useListTableVariantContext = () =>
  useContext(ListTableVariantContext);

export default ListTableVariantContext;
